import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataConnectService } from 'src/app/services/data-connect.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-visualizar',
  templateUrl: './visualizar.component.html',
  styleUrls: ['./visualizar.component.css']
})
export class VisualizarComponent implements OnInit {
  datos: any;
  imagenes: any;

  image: any
  id: number;
  datosAsig: any;
  glosa: any;
  base64: any;
  test: any;
  imageName: string;
  imageBlob: any;
  imgidsolicitud: any;
  conectado: any = {
    correcto: 'true',
    message: ""
  }

  constructor(private router: Router, private route: ActivatedRoute, private _service: DataConnectService, public auth: AuthService, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    // this._service.verificaTokenOficial().subscribe((res: any) => {
    //   this.conectado = res

      // if (this.conectado.correcto) {
        this.route.params.subscribe(params => {
          //console.log(params)
          this.id = params['IDSolicitud']; // (+) converts string 'id' to a number
        });
        this.ver(this.id)
    //   }
    //   else {
    //     console.log("desconectar")
    //     this.auth.logout();
    //   }
    // })
  }

  irfiltro(){
    console.log('irfiltro')
    this._service.volver=true;
    this.router.navigate(['inicio'])
  }

  ver(IDSolicitud) {
    return this._service.ver(IDSolicitud, 1034).subscribe(
      resp => {
        this.datos = resp.solicitud
        this.glosa = this.datos[0].GLSolicitud
        this.datosAsig = resp.asignacion
        this.imagenes = resp.imagenes
        //this.verimg(IDSolicitud)
      }
    )
  }
  dataURItoBlob(dataURI, formato) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    var formatoaux;
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    if (formato == 'PDF') {
      formatoaux = 'application/PDF'
    } else if (formato == 'JPG' || formato == 'PNG') {
      formatoaux = `image/${formato}`
    } else if (formato == 'DOC') {
      formatoaux = 'application/msword'
    } else if (formato == 'XLS') {
      formatoaux = 'application/vnd.ms-excel'
    }
    const blob = new Blob([int8Array], { type: formatoaux });
    return blob;
  }
  imagenes2(idSolicitud) {
    this.test = ''
    return this._service.Imagenes(idSolicitud).subscribe(
      res => {
        //console.log(res)
        this.image = res;

      });
  }
  verimg(IDSolicitud, NMTPFormato, index) {

    this.test = ''
    this.imgidsolicitud = IDSolicitud
    //console.log(NMTPFormato)
    //this.image.forEach(element => {
    if (this.image[index].IDSolicitud == IDSolicitud && NMTPFormato == this.image[index].NMTPFormato) {
      if (NMTPFormato == 'PDF') {
        //          this.test = {obj: this.sanitizer.bypassSecurityTrustHtml(`<object class="img-thumbnail"
        // data="${this.image[index].imgbase64}" type = "application/pdf" > </object>`), indice :index}
        this.base64 = this.image[index].imgbase64.split(',')
        //console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], this.imageName, { type: `application/${NMTPFormato}` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);

        //console.log(this.test)
      } else if (NMTPFormato == 'JPG' || NMTPFormato == 'PNG') {
        // this.test = {obj: this.sanitizer.bypassSecurityTrustHtml(`<img class="img-thumbnail"
        // src="${this.image[index].imgbase64}" > </img>`), indice : index}
        this.base64 = this.image[index].imgbase64.split(',')
        // console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], `Adjunto.${NMTPFormato}`, { type: `image/${NMTPFormato}` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);
      } else if (NMTPFormato == 'DOC') {
        this.base64 = this.image[index].imgbase64.split(',')
        //console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], `Adjunto.${NMTPFormato}`, { type: `application/msword` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);
      } else if (NMTPFormato == 'XLS') {
        this.base64 = this.image[index].imgbase64.split(',')
        //console.log(this.base64[1])
        this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${this.image[index].imgbase64}`), indice: index }
        this.imageName = `Adjunto.${NMTPFormato}`;
        this.imageBlob = this.dataURItoBlob(this.base64[1], NMTPFormato);
        this.test = new File([this.imageBlob], `Adjunto.${NMTPFormato}`, { type: `application/vnd.ms-excel` });
        const url = window.URL.createObjectURL(this.test);
        window.open(url);
      }

      //return this.test
    }
    // })
  }
}
